import * as ng from 'angular';

export class PagerController implements ng.IController {
   itemsPerPage:number;
   total:number;
   page:number;
   onPageChange:Function;

   get noPrevious():boolean {
      return this.page == 1;
   }

   get noNext():boolean {
      return this.page == this.lastPage;
   }

   get lastPage():number {
      if (this.total) {
         return Math.ceil(this.total / this.itemsPerPage);
      }

      return 1;
   }

   get pageFront():number {
      if (this.total) {
         return ((this.page - 1) * this.itemsPerPage) + 1;
      }

      return 0;
   }

   get pageBack():number {
      if (this.total) {
         return Math.min(this.pageFront + this.itemsPerPage - 1, this.total);
      }

      return 0;
   }

   selectPage(page:number, $event:MouseEvent) {
      $event.preventDefault();
      this.onPageChange({$page: page});
   }
}

ng.module('e360').component('pager', {
   templateUrl: require('./pager.component.html'),
   controller: PagerController,
   bindings: {
      itemsPerPage: '<',
      total: '<',
      page: '<',
      onPageChange: '&'
   }
});
